export default __webpack_public_path__ + "static/media/right-works.52463805.webp";